module.exports = require('./lib/core/core');


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/core.js
// module id = 887
// module chunks = 0